import React from 'react';
import codeTyping from '../img/CodeTyping.svg';

export default function Skill(){
  const skill = [
    ["HTML5", 95],
    ["CSS3", 88],
    ["SEO", 90],
    ["JS", 60],
    ["TS", 50],
    /*["Angular", 15],*/
    ["JQuery", 85],
    /*["RestFul API", 40],*/
    ["JSON", 80],
    /*["MongoDB", 20],
    ["Express", 5],*/
    ["React.js", 30],
    ["Node.js", 70],
    ["React Native", 15],
    /*["NestJS", 25],*/
    ["Laravel", 30],
    ["Spring Boot", 70],
    ["PHP", 50],
    ["SQL", 90],
    ["MySQL", 75],
    /*["PostgreSQL", 20],
    ["Dart", 20],
    ["Flutter", 10],*/
    ["UI/UX Design", 40],
    ["Responsive Web Design", 90],
    ["WordPress", 40],
    ["Python", 40],
    ["C", 60],
    ["C++", 60],
    ["Java", 70],
    ["LISP", 40],
    ["Haskell", 40],
    ["Git", 65],
    ["GitHub", 65]
  ];
  const skills = skill.map(
    (skil) =>
      <div>
        <h4> {skil[0]} <progress min='0' max='100' value={skil[1]}></progress> </h4>
      </div>
    );

    return(
        <section className='skillSection'>
          <h3 className='sectionTitle' id='skills'> {" What I know ? (Skills)"} </h3>
          <br/>
          <br/>
          <div className='skillsBox'>
            <div className='skillImg'>
              <img src={codeTyping} alt="" /> 
            </div>

            <div className='skill'>
              {skills}
            </div>
          </div>
        </section>
    );
}